import { memo } from 'react';

import { Box, Link, rem } from '@vimeo/bokeh';

import { default as VimeoIllustration } from '../../illustrations/Vimeo.svg';

export const LiveErrorPageHeader = memo(function () {
  return (
    <Box
      position={'relative'}
      width={'100%'}
      paddingY={rem(12)}
      paddingX={32}
      minHeight={rem(60)}
      as={'header'}
    >
      <Link href={'/'}>
        <Box
          width={rem(100)}
          cursor={'pointer'}
          sx={{
            '& path': { fill: 'text-primary' },
          }}
        >
          <VimeoIllustration />
        </Box>
      </Link>
    </Box>
  );
});
